import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HotToastService } from '@ngneat/hot-toast';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { ShoppingCartItemDto } from 'src/app/core/dtos/dto';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { ShoppingCartService } from 'src/app/core/services/shopping-cart.service';
import { loadShoppingCart } from 'src/app/state/shopping-cart.actions';

@Component({
  selector: 'app-item-quantity',
  templateUrl: './item-quantity.component.html',
  styleUrls: ['./item-quantity.component.scss']
})
export class ItemQuantityComponent implements OnInit {
  @Input() item: ShoppingCartItemDto;
  @Input() currencyCode: string;

  quantityInput: FormGroup;
  updateItemQuantitySusbscriptipn: Subscription;

  constructor(
    private fb: FormBuilder,
    private shoppingCartService: ShoppingCartService,
    private toastService: HotToastService,
    private store: Store
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.quantityInput.valueChanges.subscribe(val => {
      this.updateItemQuantitySusbscriptipn = this.shoppingCartService.updateShoppingCartItem(this.item.id, val.quantity)
        .subscribe(
          result => {
            this.store.dispatch(loadShoppingCart({ shoppingCart: result.content }));
          },
          (error: HttpErrorResponse) => {
            if (error.status === 400) {
              const errorMessage = error.error as HttpErrorResponseMessages;
              errorMessage.reasons.forEach(reasons => {
                this.toastService.warning(reasons.errorMessage);
              });
            }
          }
        );
    });
  }

  createForm() {
    this.quantityInput = this.fb.group({
      quantity: this.item.quantity
    });
  }

}
